module.exports = __webpack_public_path__ + "img/rate-2.049afb47.svg";